import { LogErrors } from './../../LogErrors'
import { DoubleAttempt } from './../Helpers/DoubleAttempt'


/**
 * Realiza la llamada a la API para crear una nueva sesión para las dinámicas.
 * @param {Object} ztudentData Información del ztudiante
 * @returns {Object} Resultado del proceso { success: boolean, data: Object, message: string }
 */
const CreateSession = async (ztudentData) => {
  try {
    const parameters = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(ztudentData)
    }

    //const url = `${process.env.REACT_APP_GAMES_URL}ztudiaauth/add`
    const url = `${process.env.REACT_APP_INTERNAL_API_URL}ZtudiaGames/link`
    const response = await DoubleAttempt(url, parameters)
    
    if (response.success) {
      //const magicLink = response?.data?.magicLink
      const magicLink = response.data?.magicLink ?? response.magicLink;

      if (!magicLink) {
        return { success: false, message: 'No se ha podido obtener la información solicitada. Inténtalo de nuevo o inténtalo más tarde.' }
      } else {
        return { success: true, data: `${magicLink}?utm_source=app_ztudia_web&utm_medium=banner_dashboard&utm_campaign=ztudent_day_2026`}
      }
    } else {
        return { success: false, message: response.message }
    }
  } catch (error) {
    await LogErrors('CreateSession - DL Games', error)
    return { success: false, message: '' }
  }
}

// Obtener el estado actual del juego
const GetGameStatus = async (centerId, gameIdentifier) => {
    try {
        const parameters = {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        }
        // Reemplaza REACT_APP_ARCADE_API_URL por la variable de entorno de tu nuevo servidor clon
        const url = `${process.env.REACT_APP_INTERNAL_API_URL}ztudiagames/status/${centerId}/${gameIdentifier}`
        const response = await DoubleAttempt(url, parameters)
        
        return response; // Esperamos { success: true, isActive: true/false }
    } catch (error) {
        await LogErrors('GetGameStatus - DL Games', error)
        return { success: false, isActive: false }
    }
}

// Cambiar el estado del juego
const ToggleGameAccess = async (toggleData) => {
    try {
        const parameters = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(toggleData)
        }
        
        const url = `${process.env.REACT_APP_INTERNAL_API_URL}ztudiagames/toggle`
        const response = await DoubleAttempt(url, parameters)
        
        return response;
    } catch (error) {
        await LogErrors('ToggleGameAccess - DL Games', error)
        return { success: false, message: 'Error al cambiar el estado del juego' }
    }
}

export { CreateSession, GetGameStatus, ToggleGameAccess };